import { Role } from "@/router/_helper";

  const student = {
    path: "/student",
    name: "student",
    component: () => import(/* webpackChunkName: "student" */ "@/components/student/StudentIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "student" */ "@/components/student/StudentView.vue"), name: "studentView", meta: { authorize: [Role.Admin, Role.ComplianceStudent], requiresAuth: true }},
      { path: "edit/:id", component: () => import(/* webpackChunkName: "student" */ "@/components/student/StudentEdit.vue"), name: "studentEdit", meta: { authorize: [Role.Admin, Role.ComplianceStudent], requiresAuth: true }},
      { path: "create", component: () => import(/* webpackChunkName: "student" */ "@/components/student/StudentCreate.vue"), name: "studentCreate", meta: { authorize: [Role.Admin, Role.ComplianceStudent], requiresAuth: true }},
      { path: "upload", component: () => import(/* webpackChunkName: "student" */ "@/components/student/StudentUpload.vue"), name: "studentUpload", meta: { authorize: [Role.Admin, Role.ComplianceStudent], requiresAuth: true }}
    ],
    meta: { authorize: [Role.Admin, Role.ComplianceStudent], requiresAuth: true }
  };

export default student;
    